import {
	selectMaxUsableBatteryCapacity,
	selectSolarLuminarCountValue, selectSolarLuminarPower, selectSolarMaxLumen,
	selectSolarPowerRequirementsBySeason,
	selectSolarPVMaxInput
} from '../solar/solarSelectors';

export function getPower(season, generators, state) {
	const powerRequirement = selectSolarPowerRequirementsBySeason(state)?.[season];
	const maxPVInput = selectSolarPVMaxInput(state)[generators - 1]?.[season];
	const maxUsableBatteryCapcity = selectMaxUsableBatteryCapacity(state);
	const usableInput = Math.min(maxPVInput, maxUsableBatteryCapcity);
	const usedInputFactor = powerRequirement / usableInput;
	const restrictionDimmingFactor = Math.min(1, 1 / usedInputFactor);
	const lumCount = selectSolarLuminarCountValue(state) ?? 1;
	let luminarPower = Math.round(selectSolarLuminarPower(state) * restrictionDimmingFactor * 10) / 10;
	if (lumCount > 1) {
		if (luminarPower > selectSolarLuminarPower(state)/lumCount) luminarPower = selectSolarLuminarPower(state)/lumCount;
	}
	return luminarPower ?? '-';
}
export function getLumen(season, generators, state) {
	const powerRequirement = selectSolarPowerRequirementsBySeason(state)?.[season];
	const maxPVInput = selectSolarPVMaxInput(state)[generators - 1]?.[season];
	const maxUsableBatteryCapcity = selectMaxUsableBatteryCapacity(state);
	const usableInput = Math.min(maxPVInput, maxUsableBatteryCapcity);
	const usedInputFactor = powerRequirement / usableInput;
	const restrictionDimmingFactor = Math.min(1, 1 / usedInputFactor);
	const lumCount = selectSolarLuminarCountValue(state) ?? 1;
	let maxLumenDimmed = Math.round(selectSolarMaxLumen(state) * restrictionDimmingFactor);
	if (lumCount > 1) {
		if (maxLumenDimmed > selectSolarMaxLumen(state)/lumCount) maxLumenDimmed = selectSolarMaxLumen(state)/lumCount;
	}
	return maxLumenDimmed ?? '-';
}
